import { Button, Form, Upload, Space, message, Input, Select, Divider, Typography, Col, Row } from "antd";
import { FileTextOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { getClassificacoes } from "../../../../api/classificacoes";
import { useState, useEffect, Fragment } from "react";
import TextArea from "antd/es/input/TextArea";
const { Text } = Typography;
const { Dragger } = Upload;

const validator = {
  experiencias: [{ required: true, message: "Informe as experiências!" }],
  id_cad_classificacao_escolaridade: [{ required: true, message: "Selecione o ensino!" }],
  descricao: [{ required: true, message: "Informe o curso!" }],
};

const Curriculo = ({ onFinish, onPrevious, loadingComponent }) => {
  const [loading, setLoading] = useState(false);
  const [classificacoes, setClassificacoes] = useState([]);
  const [form] = Form.useForm();
  const formacoes = Form.useWatch("formacoes", form);

  const onSubmit = (values) => {
    onFinish(values);
  };

  useEffect(() => {
    listarClassificacoes();
  }, []);

  const listarClassificacoes = async () => {
    setLoading(true);
    try {
      const retorno = await getClassificacoes();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_classificacoes = [];
        for (let index = 0; index < data?.length; index++) {
          array_classificacoes.push({
            value: data?.[index]?.id,
            label: data?.[index]?.descricao,
            complemento: data?.[index]?.complemento,
          });
        }
        setClassificacoes(array_classificacoes);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const formFile = (e) => {
    const isJpgOrPng =
      e?.file?.type === "application/pdf" ||
      e?.file?.type === "application/msword" ||
      e?.file?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    if (!isJpgOrPng) {
      message.error("Selecione um documento PDF, DOC ou DOCX!");
      return null;
    }
    const isLt2M = e?.file?.size / 1024 / 1024 > 20;
    if (isLt2M) {
      message.error("Tamanho não suportado, máximo 20MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const renderClassificacoesComplementos = (classificacoes_array) => {
    const obj = {};

    classificacoes_array?.forEach((element) => {
      obj[element?.value] = element?.complemento === 1 ? true : false;
    });

    return obj;
  };

  const classificacoesComplemento = classificacoes?.length > 0 ? renderClassificacoesComplementos(classificacoes) : {};

  return (
    <Form form={form} initialValues={{ formacoes: [""] }} layout="vertical" autoComplete="off" onFinish={onSubmit}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Text strong>Formações</Text>
        <Form.List name="formacoes">
          {(fields, { add, remove }) => (
            <Fragment>
              {fields.map(({ key, name }) => (
                <div key={key} align="baseline" style={{ width: "100%", display: "flex", gap: 10 }}>
                  <Row gutter={{ xs: 5, sm: 5, md: 5, lg: 10 }} style={{ flexGrow: 1 }}>
                    <Col
                      className="gutter-row"
                      {...(classificacoesComplemento[formacoes?.[name]?.id_cad_classificacao_escolaridade]
                        ? { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 }
                        : { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 })}>
                      <Form.Item
                        name={[name, "id_cad_classificacao_escolaridade"]}
                        rules={validator?.id_cad_classificacao_escolaridade}>
                        <Select listHeight={350} size="large" placeholder="Ensino" options={classificacoes} />
                      </Form.Item>
                    </Col>

                    {classificacoesComplemento[formacoes?.[name]?.id_cad_classificacao_escolaridade] && (
                      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item name={[name, "descricao"]} rules={validator?.descricao}>
                          <Input size="large" placeholder="Curso" />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>

                  {fields?.length > 1 && (
                    <Button
                      size="large"
                      type="text"
                      danger
                      icon={<MinusCircleOutlined />}
                      onClick={() => remove(name)}
                    />
                  )}
                </div>
              ))}
              <Form.Item>
                <Button type="dashed" size="large" onClick={() => add()} block icon={<PlusOutlined />}>
                  Adicionar Campo
                </Button>
              </Form.Item>
            </Fragment>
          )}
        </Form.List>
      </Space>

      <Divider />
      <Space direction="vertical" style={{ width: "100%" }}>
        <Text strong>Experiências</Text>
        <Col className="gutter-row" span={24}>
          <Form.Item name="experiencias" hasFeedback rules={validator?.experiencias}>
            <TextArea
              placeholder="Faça um resumo sobre suas experiências profissionais."
              disabled={loading}
              autoSize={{ minRows: 5, maxRows: 8 }}
            />
          </Form.Item>
        </Col>
      </Space>
      <Divider />

      <Text strong>Currículo (Opcional)</Text>
      <Form.Item getValueFromEvent={formFile} name="file" valuePropName="fileList" hasFeedback multiple={false}>
        <Dragger
          disabled={loading || loadingComponent}
          beforeUpload={() => false}
          accept=".pdf, .doc, .docx"
          listType="picture"
          maxCount={1}
          iconRender={() => <FileTextOutlined />}
          multiple={false}>
          <p className="ant-upload-drag-icon">
            <FileTextOutlined />
          </p>
          <p className="ant-upload-text">Adicione aqui o seu currículo (PDF, DOC, DOCX)</p>
          <p className="ant-upload-hint">Clique ou arraste para enviar o arquivo</p>
        </Dragger>
      </Form.Item>

      <Space>
        <Button size="large" loading={loading || loadingComponent} type="primary" htmlType="submit">
          Próximo
        </Button>

        <Button size="large" loading={loading || loadingComponent} onClick={onPrevious}>
          Anterior
        </Button>
      </Space>
    </Form>
  );
};

export { Curriculo };
